import React from 'react';
import EngineConfigs from '../EngineConfigs/index.es6';

export default function KYCConfigs() {
  return <EngineConfigs />;
}
